import { useContext } from 'react'

import defaultSettings from './defaultSettings'
import OrderEntryContext from './OrderEntryContext'
import { TOrderEntrySettings } from './types'

const useOrderEntry = (): TOrderEntrySettings => {
  const settings = useContext(OrderEntryContext)
  return { ...defaultSettings, ...settings }
}

export default useOrderEntry
